import { SHOPIFY } from "@faire/retailer-visitor-shared/features/PointOfSale/consts";
import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { getSessionCountry } from "@faire/retailer-visitor-shared/serialized-data/getSessionCountry";
import { QueryParameters as EnabledPOSTypesParameters } from "@faire/web-api--source/retailers-pos-api/retailer/enabled-pos-types/get";
import { useQuery as useEnabledTypesQuery } from "@faire/web-api--source/retailers-pos-api/retailer/enabled-pos-types/get-hooks";
import { useMemo } from "react";
export var useEnabledPOSTypes = function() {
    var isLoggedInRetailer = useIsLoggedInRetailer();
    var sessionCountry = isLoggedInRetailer ? undefined : getSessionCountry();
    var _useEnabledTypesQuery = useEnabledTypesQuery(EnabledPOSTypesParameters.build({
        country: sessionCountry
    })), data = _useEnabledTypesQuery.data, isLoading = _useEnabledTypesQuery.isLoading;
    var types = useMemo(function() {
        var _data_pos_types;
        return ((_data_pos_types = data === null || data === void 0 ? void 0 : data.pos_types) !== null && _data_pos_types !== void 0 ? _data_pos_types : []).sort(function(type) {
            return type === SHOPIFY ? -1 : 1;
        });
    }, [
        data
    ]);
    return {
        isLoading: isLoading,
        types: types
    };
};
